export default __webpack_public_path__ + "static/media/40.2e881695.png";